import { useRef } from 'react'
import { Popper, Box, ClickAwayListener } from '@mui/material'

export default function SubmenuPopper({
  anchorEl,
  open,
  children,
  onClickAway,
}: {
  anchorEl: HTMLElement | null
  open: boolean
  children: React.ReactNode
  onClickAway: (event: MouseEvent | TouchEvent) => void
}) {
  const ref = useRef(null)

  return (
    <Popper
      open={open}
      anchorEl={anchorEl}
      placement="right-end"
      disablePortal
      modifiers={[{ name: 'offset', options: { offset: [0, 0] } }]}
      style={{ zIndex: 1300 }}
    >
      <ClickAwayListener onClickAway={onClickAway}>
        <Box ref={ref}>{children}</Box>
      </ClickAwayListener>
    </Popper>
  )
}
